import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IListProjectAdvancedRequest extends IBaseRequest {
    limit?:     number;
    offset?:    number;
    orderBy?:   string;
    countOnly?: boolean;
    formItems?: FormItems;
    FILTER?:    Filter;
    ORDER?:     Order;
    FIELDS?:    Fields;
}

export interface Fields {
    field: string[];
}

function toFieldsXml(fields: Fields): string {
    return fields.field.map((field: string) => {
        return `<field>${field}</field>`;
    }).join('');
}

export interface Filter {
    COL: FilterCol[];
}

function toFilterXml(filter: Filter): string {
    return filter.COL.map((col: FilterCol) => {
        return toFilterColXml(col);
    }).join('');
}

export interface FilterCol {
    name:        string;
    type:        string;
    value?:       string;
    negation?:    string;
    includeNull?: string;
}

function toFilterColXml(col:FilterCol): string{
    var xml = `<name>${col.name}</name><type>${col.type}</type>`;

    if(col.value) xml += `<value>${col.value}</value>`;
    if(col.negation) xml += `<negation>${col.negation}</negation>`;
    if(col.includeNull) xml += `<includeNull>${col.includeNull}</includeNull>`;

    return `<COL>${xml}</COL>`;
}
export interface Order {
    COL: OrderCol[];
}

function toOrderXml(order: Order): string {
    return order.COL.map((orderCol: OrderCol) => {
        return toOrderColXml(orderCol);
    }).join('');
}

export interface OrderCol {
    name: string;
    desc: string;
}

function toOrderColXml(orderCol: OrderCol): string {
    return `<COL><name>${orderCol.name}</name><desc>${orderCol.desc}</desc></COL>`;
}

export interface FormItems {
    formItem: string[];
}

function toFormItemsXml(formItems: FormItems): string {
    return formItems.formItem.map((formItem: string) => {
        return `<formItem>${formItem}</formItem>`;
    }).join('');
}

export class ListProjectAdvancedRequest extends BaseRequest implements IListProjectAdvancedRequest {

    public limit?:     number;
    public offset?:    number;
    public orderBy?:   string;
    public countOnly?: boolean;
    public formItems?: FormItems;
    public FILTER?:    Filter;
    public ORDER?:     Order;
    public FIELDS?:    Fields;

    constructor(server: string, session: string, otherOptions: any) {
        super(server, session);
        this.limit = otherOptions.limit;
        this.offset = otherOptions.offset;
        this.orderBy = otherOptions.orderBy;
        this.countOnly = otherOptions.countOnly;
        this.formItems = otherOptions.formItems;
        this.FILTER = otherOptions.FILTER;
        this.ORDER = otherOptions.ORDER;
        this.FIELDS = otherOptions.FIELDS;
    }

    public toXml(): string {
        var parameters: string = super.toXml();

        if(this.limit) parameters += `<limit>${this.limit}</limit>`;
        if(this.offset) parameters += `<offset>${this.offset}</offset>`;
        if(this.orderBy) parameters += `<orderBy>${this.orderBy}</orderBy>`;
        if(this.countOnly) parameters += `<countOnly>${this.countOnly}</countOnly>`;
        if(this.formItems) parameters += `<formItems>${toFormItemsXml(this.formItems)}</formItems>`;
        if(this.FILTER) parameters += `<FILTER>${toFilterXml(this.FILTER)}</FILTER>`;
        if(this.ORDER) parameters += `<ORDER>${toOrderXml(this.ORDER)}</ORDER>`;
        if(this.FIELDS) parameters += `<FIELDS>${toFieldsXml(this.FIELDS)}</FIELDS>`;
        
        return super.wrapperXml('ListProjectAdvanced', parameters);
    }
}
